import React from "react";
import styled from "styled-components";
import { FaPlay } from "react-icons/fa";

const Categories = () => {
  return (
    <Wrapper>
      <section className="about-section" style={{ marginTop: "70px" }}>
        {/* ===== Section Title ===== */}
        <div className="rs-section-title-wrapper">
          <span className="rs-section-subtitle has-theme-orange justify-content-center">
            <FaPlay color="#EA5501" size={12} />
            Categories
          </span>
        </div>

        <div className="container pt-4">
          {/* ===== Categories List ===== */}
          <div className="row about-lists">
            {/* ===== 01 Agro Net ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
            >
              <div className="content-item">
                <span className="serial">01</span>

                <h4>Agro Net</h4>

                <p>
                  We are manufacturing, supplying, exporting and trading wide
                  range of Agricultural Net. We offer our products in market in
                  minimum cost. In addition to this, the offered range is
                  stringently tested on various parameters before delivering it
                  to the clients.
                </p>
              </div>
            </div>

            {/* ===== 02 Fishing Net ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-item">
                <span className="serial">02</span>

                <h4>Fishing Net</h4>

                <p>
                  Our PE Nets are made from HDPE granules using High Tech
                  Extrusion line. Each product is subjected to rigorous tests
                  for weather ability. Beside HDPE fishing nets, we also produce
                  HDPE nets for vast range of netting applications, such as;
                  Fencing nets, Vegetable nets, Poultry nets, Construction
                  safety nets, etc.
                </p>
              </div>
            </div>

            {/* ===== 03 Mosquito Net ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="content-item">
                <span className="serial">03</span>

                <h4>Mosquito Net</h4>

                <p>
                  Our PE Nets are made from HDPE granules using High Tech
                  Extrusion line. Each product is subjected to rigorous tests
                  for weather ability. Beside HDPE fishing nets, we also produce
                  HDPE nets for vast range of netting applications, such as;
                  Fencing nets, Vegetable nets, Poultry nets, Construction
                  safety nets, etc.
                </p>
              </div>
            </div>

            {/* ===== 04 Food Processing Net ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="content-item">
                <span className="serial">04</span>

                <h4>Food Processing Net</h4>

                <p>
                  Our PE Nets are made from HDPE granules using High Tech
                  Extrusion line. Each product is subjected to rigorous tests
                  for weather ability. Beside HDPE fishing nets, we also produce
                  HDPE nets for vast range of netting applications, such as;
                  Fencing nets, Vegetable nets, Poultry nets, Construction
                  safety nets, etc.
                </p>
              </div>
            </div>

            {/* ===== 05 Building Safety Net ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="content-item">
                <span className="serial">05</span>

                <h4>Building Safety Net</h4>

                <p>
                  Our PE Nets are made from HDPE granules using High Tech
                  Extrusion line. Each product is subjected to rigorous tests
                  for weather ability. Beside HDPE fishing nets, we also produce
                  HDPE nets for vast range of netting applications, such as;
                  Fencing nets, Vegetable nets, Poultry nets, Construction
                  safety nets, etc.
                </p>
              </div>
            </div>

            {/* ===== 06 Garments Accessories ===== */}
            <div
              className="col-lg-4 col-md-6 col-12 content-item-wrapper"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="content-item">
                <span className="serial">06</span>

                <h4>Garments Accessories</h4>

                <p>
                  We produce all kinds of twill tapes, Grosgrain tapes, Hanger
                  loops, Satin ribbon, Elastics (Plain & woven), Printed fabric
                  label (PFL), and Gum tape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .about-lists {
    margin-left: -10px;
    margin-right: -10px;
  }

  /* ===== Individual Card Wrapper ===== */
  .content-item-wrapper {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 20px;
  }

  /* ===== Individual Category Card ===== */
  .content-item {
    height: 100%;
    padding: 35px 30px;
    background: #ffffff;

    /* Border on ALL four sides */
    border: 1px solid #d9e8f4;

    /* Smooth card corners */
    border-radius: 4px;

    /* Small clean shadow */
    box-shadow: 0 4px 18px rgba(33, 144, 166, 0.05);

    transition: all 0.3s ease;
  }

  /* ===== Card Hover ===== */
  .content-item:hover {
    transform: translateY(-5px);
    /* border-color: #2190a6; */
    border-color: #ea5501;
    box-shadow: 0 10px 30px rgba(33, 144, 166, 0.12);
  }

  /* ===== Serial Number ===== */
  .serial {
    display: inline-block;
    margin-bottom: 12px;

    color: #ea5501;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 1px;
  }

  /* ===== Card Title ===== */
  .content-item h4 {
    margin: 0 0 18px;
    color: #1d2d35;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;

    transition: color 0.3s ease;
  }

  .content-item:hover h4 {
    color: #ea5501;
  }

  /* ===== Card Description ===== */
  .content-item p {
    margin: 0;
    color: #6b7280;
    font-size: 15px;
    line-height: 1.8;
    text-align: justify;
  }

  /* ===== Tablet ===== */
  @media (max-width: 991px) {
    .content-item {
      padding: 30px 25px;
    }

    .content-item h4 {
      font-size: 20px;
    }
  }

  /* ===== Mobile ===== */
  @media (max-width: 767px) {
    .about-lists {
      margin-left: -8px;
      margin-right: -8px;
    }

    .content-item-wrapper {
      padding-left: 8px;
      padding-right: 8px;
      margin-bottom: 16px;
    }

    .content-item {
      padding: 28px 22px;
    }

    .content-item h4 {
      font-size: 19px;
      margin-bottom: 14px;
    }

    .content-item p {
      font-size: 14px;
      line-height: 1.7;
    }
  }
`;

export default Categories;
